var RepeatTypeEnum = /* @__PURE__ */ ((RepeatTypeEnum2) => {
  RepeatTypeEnum2["DAILY"] = "DAILY";
  RepeatTypeEnum2["DAY_IN_WEEK"] = "DAY_IN_WEEK";
  RepeatTypeEnum2["CUSTOM"] = "CUSTOM";
  RepeatTypeEnum2["NO_REPEAT"] = "NO_REPEAT";
  return RepeatTypeEnum2;
})(RepeatTypeEnum || {});
var UnitRepeatEnum = /* @__PURE__ */ ((UnitRepeatEnum2) => {
  UnitRepeatEnum2["DAY"] = "DAILY";
  UnitRepeatEnum2["WEEK"] = "WEEKLY";
  UnitRepeatEnum2["MONTH"] = "MONTH";
  UnitRepeatEnum2["YEAR"] = "YEAR";
  UnitRepeatEnum2["DURATION"] = "DURATION";
  return UnitRepeatEnum2;
})(UnitRepeatEnum || {});
var RuleRepeatEnum = /* @__PURE__ */ ((RuleRepeatEnum2) => {
  RuleRepeatEnum2["FREQ"] = "FREQ";
  RuleRepeatEnum2["INTERVAL"] = "INTERVAL";
  RuleRepeatEnum2["BYDAY"] = "BYDAY";
  RuleRepeatEnum2["UNTIL"] = "UNTIL";
  return RuleRepeatEnum2;
})(RuleRepeatEnum || {});

export { RepeatTypeEnum, RuleRepeatEnum, UnitRepeatEnum };
